<template>
    <div>
        <div style="height: 20vh;" class="inapp-hide"></div>
        <Riassunto :iscrizione="true"/>

        <div class="race-app-header inapp-show"></div>

        <div class="v-step step" v-bind:class="{ 'active': step === 0 }"
             @click="focusStep" @keyup.enter.stop="next()">
            <div class="k-card" style="width:100%">
                <div class="k-card-body" style="width:100%">
                    <div class="k-card-img">
                        <img :src="testi_donazione.maglia_img">
                    </div>
                    <div class="k-card-text" style="font-size:120%">
                        <div class="k-card-text--description" v-html="testi_donazione.maglia_testo"></div>
                    </div>
                </div>
            </div>
            <div class="v-step__footer-step">
                <b-button class="v-step__next-btn" @click="next">
                    Ok
                </b-button>
                <div class="v-step__next-info">Premi <b>INVIO</b> per continuare</div>
            </div>
        </div>

        <div class="v-step step" v-bind:class="{ 'active': step === 1 }"
             @click="focusStep">
            <b-form-group label="Maglia Race Adulto<span class='d-block small'>Seleziona la quantità desiderata</span>">

                <div>
                    <div class="d-flex align-items-center justify-content-start pl-lg-5 mt-4 w-100">
                        <div class="denied-btn mr-2" @click="next">No, grazie</div>
                        <div class="accepted-btn" v-b-toggle.maglia-adulto-collapse>Scegli</div>
                    </div>

                    <b-collapse id="maglia-adulto-collapse" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between w-100 mb-2 mt-4">
                            <div class="d-inline-block small w-auto text-uppercase font-weight-bold m-0">S - Small</div>
                            <div class="d-inline-block">
                                <div class="d-flex align-items-center justify-content-end w-100">
                                    <div class="border border-light rounded mr-3" style="width: 60px;">
                                        <b-input class="text-center m-0 border-0 px-0" v-model="form.taglia_s_adulto" disabled="disabled"></b-input></div>
                                    <div class="button-remove-add">
                                        <div @click="diminuisci('taglia_s_adulto')" :class="{ 'disabled': form.taglia_s_adulto <= 0 }"><img src="/static/svg/icons/minus-icon.svg" height="15"></div>
                                        <div @click="aumenta('taglia_s_adulto')"><img src="/static/svg/icons/plus-icon.svg" height="15"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between w-100 mb-2">
                            <div class="d-inline-block small w-auto text-uppercase font-weight-bold m-0">M - Medium</div>
                            <div class="d-inline-block">
                                <div class="d-flex align-items-center justify-content-end w-100">
                                    <div class="border border-light rounded mr-3" style="width: 60px;">
                                        <b-input class="text-center m-0 border-0 px-0" v-model="form.taglia_m_adulto" disabled="disabled"></b-input></div>
                                    <div class="button-remove-add">
                                        <div @click="diminuisci('taglia_m_adulto')" :class="{ 'disabled': form.taglia_m_adulto <= 0 }"><img src="/static/svg/icons/minus-icon.svg" height="15"></div>
                                        <div @click="aumenta('taglia_m_adulto')"><img src="/static/svg/icons/plus-icon.svg" height="15"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between w-100 mb-2">
                            <div class="d-inline-block small w-auto text-uppercase font-weight-bold m-0">L - Large</div>
                            <div class="d-inline-block">
                                <div class="d-flex align-items-center justify-content-end w-100">
                                    <div class="border border-light rounded mr-3" style="width: 60px;">
                                        <b-input class="text-center m-0 border-0 px-0" v-model="form.taglia_l_adulto" disabled="disabled"></b-input></div>
                                    <div class="button-remove-add">
                                        <div @click="diminuisci('taglia_l_adulto')" :class="{ 'disabled': form.taglia_l_adulto <= 0 }"><img src="/static/svg/icons/minus-icon.svg" height="15"></div>
                                        <div @click="aumenta('taglia_l_adulto')"><img src="/static/svg/icons/plus-icon.svg" height="15"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between w-100">
                            <div class="d-inline-block small w-auto text-uppercase font-weight-bold m-0">XL - Extra Large</div>
                            <div class="d-inline-block">
                                <div class="d-flex align-items-center justify-content-end w-100">
                                    <div class="border border-light rounded mr-3" style="width: 60px;">
                                        <b-input class="text-center m-0 border-0 px-0" v-model="form.taglia_xl_adulto" disabled="disabled"></b-input></div>
                                    <div class="button-remove-add">
                                        <div @click="diminuisci('taglia_xl_adulto')" :class="{ 'disabled': form.taglia_xl_adulto <= 0 }"><img src="/static/svg/icons/minus-icon.svg" height="15"></div>
                                        <div @click="aumenta('taglia_xl_adulto')"><img src="/static/svg/icons/plus-icon.svg" height="15"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="v-step__footer-step">
                            <!--<div class="btn btn-light mr-2" v-b-toggle.maglia-adulto-collapse>No, grazie</div>-->
                            <b-button class="v-step__next-btn" variant="primary" @click="next">Continua</b-button>
                        </div>
                    </b-collapse>
                </div>
            </b-form-group>
        </div>

        <div class="v-step step" v-bind:class="{ 'active': step === 2 }"
             @click="focusStep">
            <b-form-group label="Maglia Race Donna in Rosa<span class='d-block small'>Seleziona la quantità desiderata</span>">
                <div>
                    <div class="d-flex align-items-center justify-content-start pl-lg-5 mt-4 w-100">
                        <div class="denied-btn mr-2" @click="next">No, grazie</div>
                        <div class="accepted-btn" v-b-toggle.maglia-donna-collapse>Scegli</div>
                    </div>

                    <b-collapse id="maglia-donna-collapse" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between w-100 mb-2 mt-4">
                            <div class="d-inline-block small w-auto text-uppercase font-weight-bold m-0">S - Small</div>
                            <div class="d-inline-block">
                                <div class="d-flex align-items-center justify-content-end w-100">
                                    <div class="border border-light rounded mr-3" style="width: 60px;">
                                        <b-input class="text-center m-0 border-0 px-0" v-model="form.taglia_s_rosa" disabled="disabled"></b-input></div>
                                    <div class="button-remove-add">
                                        <div @click="diminuisci('taglia_s_rosa')" :class="{ 'disabled': form.taglia_s_rosa <= 0 }"><img src="/static/svg/icons/minus-icon.svg" height="15"></div>
                                        <div @click="aumenta('taglia_s_rosa')"><img src="/static/svg/icons/plus-icon.svg" height="15"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between w-100 mb-2">
                            <div class="d-inline-block small w-auto text-uppercase font-weight-bold m-0">M - Medium</div>
                            <div class="d-inline-block">
                                <div class="d-flex align-items-center justify-content-end w-100">
                                    <div class="border border-light rounded mr-3" style="width: 60px;">
                                        <b-input class="text-center m-0 border-0 px-0" v-model="form.taglia_m_rosa" disabled="disabled"></b-input></div>
                                    <div class="button-remove-add">
                                        <div @click="diminuisci('taglia_m_rosa')" :class="{ 'disabled': form.taglia_m_rosa <= 0 }"><img src="/static/svg/icons/minus-icon.svg" height="15"></div>
                                        <div @click="aumenta('taglia_m_rosa')"><img src="/static/svg/icons/plus-icon.svg" height="15"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between w-100 mb-2">
                            <div class="d-inline-block small w-auto text-uppercase font-weight-bold m-0">L - Large</div>
                            <div class="d-inline-block">
                                <div class="d-flex align-items-center justify-content-end w-100">
                                    <div class="border border-light rounded mr-3" style="width: 60px;">
                                        <b-input class="text-center m-0 border-0 px-0" v-model="form.taglia_l_rosa" disabled="disabled"></b-input></div>
                                    <div class="button-remove-add">
                                        <div @click="diminuisci('taglia_l_rosa')" :class="{ 'disabled': form.taglia_l_rosa <= 0 }"><img src="/static/svg/icons/minus-icon.svg" height="15"></div>
                                        <div @click="aumenta('taglia_l_rosa')"><img src="/static/svg/icons/plus-icon.svg" height="15"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between w-100">
                            <div class="d-inline-block small w-auto text-uppercase font-weight-bold m-0">XL - Extra Large</div>
                            <div class="d-inline-block">
                                <div class="d-flex align-items-center justify-content-end w-100">
                                    <div class="border border-light rounded mr-3" style="width: 60px;">
                                        <b-input class="text-center m-0 border-0 px-0" v-model="form.taglia_xl_rosa" disabled="disabled"></b-input></div>
                                    <div class="button-remove-add">
                                        <div @click="diminuisci('taglia_xl_rosa')" :class="{ 'disabled': form.taglia_xl_rosa <= 0 }"><img src="/static/svg/icons/minus-icon.svg" height="15"></div>
                                        <div @click="aumenta('taglia_xl_rosa')"><img src="/static/svg/icons/plus-icon.svg" height="15"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="v-step__footer-step">
                            <!--<div class="btn btn-light mr-2" v-b-toggle.maglia-bambino-collapse>No, grazie</div>-->
                            <b-button class="v-step__next-btn" variant="primary" @click="next">Continua</b-button>
                        </div>
                    </b-collapse>
                </div>
            </b-form-group>
        </div>

        <div class="v-step step" v-bind:class="{ 'active': step === 3 }"
             @click="focusStep">
            <b-form-group label="Maglia Race Bambino">
                <div>
                    <div class="d-flex align-items-center justify-content-start pl-lg-5 mt-4 w-100">
                        <div class="denied-btn mr-2" @click="next">No, grazie</div>
                        <div class="accepted-btn" v-b-toggle.maglia-bambino-collapse>Scegli</div>
                    </div>
                    <b-collapse id="maglia-bambino-collapse" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between w-100 mb-2 mt-4">
                            <div class="d-inline-block small w-auto text-uppercase font-weight-bold m-0">Taglia Unica</div>
                            <div class="d-inline-block">
                                <div class="d-flex align-items-center justify-content-end w-100">
                                    <div class="border border-light rounded mr-3" style="width: 60px;">
                                        <b-input class="text-center m-0 border-0 px-0" v-model="form.taglia_s_bambino" disabled="disabled"></b-input></div>
                                    <div class="button-remove-add">
                                        <div @click="diminuisci('taglia_s_bambino')" :class="{ 'disabled': form.taglia_s_bambino <= 0 }"><img src="/static/svg/icons/minus-icon.svg" height="15"></div>
                                        <div @click="aumenta('taglia_s_bambino')"><img src="/static/svg/icons/plus-icon.svg" height="15"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between w-100 mb-2">
                            <div class="d-inline-block small w-auto text-uppercase font-weight-bold m-0">M - 6-8 Anni</div>
                            <div class="d-inline-block">
                                <div class="d-flex align-items-center justify-content-end w-100">
                                    <div class="border border-light rounded mr-3" style="width: 60px;">
                                        <b-input class="text-center m-0 border-0 px-0" v-model="form.taglia_m_bambino" disabled="disabled"></b-input></div>
                                    <div class="button-remove-add">
                                        <div @click="diminuisci('taglia_m_bambino')" :class="{ 'disabled': form.taglia_m_bambino <= 0 }"><img src="/static/svg/icons/minus-icon.svg" height="15"></div>
                                        <div @click="aumenta('taglia_m_bambino')"><img src="/static/svg/icons/plus-icon.svg" height="15"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between w-100 mb-2">
                            <div class="d-inline-block small w-auto text-uppercase font-weight-bold m-0">L - 9-11 Anni</div>
                            <div class="d-inline-block">
                                <div class="d-flex align-items-center justify-content-end w-100">
                                    <div class="border border-light rounded mr-3" style="width: 60px;">
                                        <b-input class="text-center m-0 border-0 px-0" v-model="form.taglia_l_bambino" disabled="disabled"></b-input></div>
                                    <div class="button-remove-add">
                                        <div @click="diminuisci('taglia_l_bambino')" :class="{ 'disabled': form.taglia_l_bambino <= 0 }"><img src="/static/svg/icons/minus-icon.svg" height="15"></div>
                                        <div @click="aumenta('taglia_l_bambino')"><img src="/static/svg/icons/plus-icon.svg" height="15"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between w-100">
                            <div class="d-inline-block small w-auto text-uppercase font-weight-bold m-0">XL - 12-14 Anni</div>
                            <div class="d-inline-block">
                                <div class="d-flex align-items-center justify-content-end w-100">
                                    <div class="border border-light rounded mr-3" style="width: 60px;">
                                        <b-input class="text-center m-0 border-0 px-0" v-model="form.taglia_xl_bambino" disabled="disabled"></b-input></div>
                                    <div class="button-remove-add">
                                        <div @click="diminuisci('taglia_xl_bambino')" :class="{ 'disabled': form.taglia_xl_bambino <= 0 }"><img src="/static/svg/icons/minus-icon.svg" height="15"></div>
                                        <div @click="aumenta('taglia_xl_bambino')"><img src="/static/svg/icons/plus-icon.svg" height="15"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="v-step__footer-step">
                            <!--<div class="btn btn-light mr-2" v-b-toggle.maglia-bambino-collapse>No, grazie</div>-->
                            <b-button class="v-step__next-btn" variant="primary" @click="next">Continua</b-button>
                        </div>
                    </b-collapse>
                </div>
            </b-form-group>
        </div>


        <div class="v-step step" v-bind:class="{ 'active': step === 4 }"
             @click="focusStep" @keyup.enter.stop="next(check_maglia)">
            <b-form-group label="Indirizzo Spedizione">
                <b-input type="email"
                         v-model="form.email"
                         :state="state('email')"
                         placeholder="Inserisci l'e-mail"
                         data-vv-name="email"
                         data-vv-as="E-Mail"
                         v-validate="'required|email'"
                         key="email"
                ></b-input>
                <span v-show="errors.has('email')" class="error">{{ errors.first('email') }}</span>

                <b-input-group class="bg-transparent border-0 text-dark">
                    <b-input v-model="form.maglia_nome"
                             :state="state('maglia_nome')"
                             placeholder="Nome"
                             autocomplete="nope"
                             data-vv-name="maglia_nome"
                             data-vv-as="nome indirizzo spedizione"
                             key="maglia_nome"
                             v-validate="'required|name'"
                    ></b-input>
                </b-input-group>
                <span v-show="errors.has('maglia_nome')" class="error">{{ errors.first('maglia_nome') }}</span>

                <b-input-group class="bg-transparent border-0 text-dark">
                    <b-input v-model="form.maglia_cognome"
                             :state="state('maglia_cognome')"
                             placeholder="Cognome"
                             autocomplete="nope"
                             data-vv-name="ref_cognome"
                             key="maglia_cognome"
                             data-vv-as="cognome indirizzo spedizione"
                             v-validate="'required|name'"
                    ></b-input>
                </b-input-group>
                <span v-show="errors.has('maglia_cognome')"
                      class="error">{{ errors.first('maglia_cognome') }}</span>

                <b-input-group class="bg-transparent border-0 text-dark">
                    <b-input v-model="form.maglia_cellulare"
                             :state="state('maglia_cellulare')"
                             placeholder="Numero di telefono"
                             autocomplete="nope"
                             data-vv-name="maglia_cellulare"
                             key="maglia_cognome"
                             data-vv-as="recapito telefonico spedizione"
                             v-validate="'required|phone'"
                    ></b-input>
                </b-input-group>
                <span v-show="errors.has('maglia_cellulare')"
                      class="error">{{ errors.first('maglia_cellulare') }}</span>


                <b-input-group class="bg-transparent border-0 text-dark">
                    <b-input v-model="form.maglia_indirizzo"
                             :state="state('maglia_indirizzo')"
                             placeholder="Indirizzo per la spedizione"
                             autocomplete="nope"
                             data-vv-name="maglia_indirizzo"
                             key="maglia_indirizzo"
                             data-vv-as="indirizzo spedizione"
                             v-validate="'required|min:3'"
                    ></b-input>
                </b-input-group>
                <span v-show="errors.has('maglia_indirizzo')"
                      class="error">{{ errors.first('maglia_indirizzo') }}</span>

                <b-input-group class="bg-transparent border-0 text-dark">
                    <b-input v-model="form.maglia_citta"
                             :state="state('maglia_citta')"
                             placeholder="Città per la spedizione"
                             autocomplete="nope"
                             data-vv-name="maglia_citta"
                             key="maglia_citta"
                             data-vv-as="città spedizione"
                             v-validate="'required|min:3'"
                    ></b-input>
                </b-input-group>
                <span v-show="errors.has('maglia_citta')"
                      class="error">{{ errors.first('maglia_citta') }}</span>


                <b-input-group class="bg-transparent border-0 text-dark">
                    <b-input v-model="form.maglia_cap"
                             :state="state('maglia_cap')"
                             placeholder="CAP"
                             autocomplete="nope"
                             data-vv-name="maglia_cap"
                             key="maglia_cap"
                             data-vv-as="cap spedizione"
                             v-validate="'required|min:3|numeric'"
                    ></b-input>
                </b-input-group>
                <span v-show="errors.has('maglia_cap')" class="error">{{ errors.first('maglia_cap') }}</span>

                <b-input-group class="border-0 select-wrapper">
                    <select v-model="form.maglia_provincia" class="border-0 custom-select" data-vv-name="maglia_provincia" v-if="province"
                            data-vv-as="provincia spedizione"
                            key="maglia_provincia"
                            placeholder="Provincia">
                        <option v-for="option in province" :value="option.value" :key="option.value">
                            {{ option.text }}
                        </option>
                    </select>

                    <!--<b-form-select v-if="province"-->
                    <!--v-model="form.maglia_provincia"-->
                    <!--:options="province"-->
                    <!--placholder="Provincia"-->
                    <!--class="border-0"-->
                    <!--data-vv-name="maglia_provincia"-->
                    <!--key="maglia_provincia"-->
                    <!--data-vv-as="provincia spedizione"-->
                    <!--&gt;</b-form-select>-->
                </b-input-group>
                <span v-show="errors.has('maglia_provincia')"
                      class="error">{{ errors.first('maglia_provincia') }}</span>
            </b-form-group>
            <div class="v-step__footer-step">
                <b-button :disabled="!check_maglia" class="v-step__next-btn" variant="primary"
                          @click="next">Continua
                </b-button>
            </div>
        </div>

        <div class="v-step step" v-bind:class="{ 'active': step === 5 }"
             @keyup.enter.stop="next(step_ok_donextra)"
             v-if="testi_donazione !== null"
             @click="focusStep">
            <b-form-group
                    label="Vuoi fare una donazione aggiuntiva?"
            >
                <div class="k-card">
                    <div class="k-card-body">
                        <div class="k-card-img align-self-center">
                            <img :src="testi_donazione.path_img">
                        </div>
                        <div class="k-card-text">
                            <div class="k-card-text--title">{{ testi_donazione.titolo }}</div>
                            <div class="k-card-text--description" v-html="testi_donazione.testo"></div>
                            <a @click="show_modale_progetto" class="k-card-text--btn cursor_pointer">Dettagli
                                Progetto</a>
                        </div>
                    </div>
                </div>


                <b-form-radio-group v-model="form.don_extra" name="don_extra" @input="checkFocus">
                    <b-form-radio :value="testi_donazione.extra1"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Dono {{ testi_donazione.extra1 }}&euro; in più
                    </b-form-radio>
                    <b-form-radio :value="testi_donazione.extra2"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Dono {{ testi_donazione.extra2 }}&euro; in più
                    </b-form-radio>

                    <b-form-radio value="extra"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline"
                                  ref="extra">
                        Importo libero
                        <b-input-group class="bg-transparent border-0 text-dark" append="&euro; in più">
                            <b-input type="text"
                                     v-model="form.don_extra_importo"
                                     :state="state('don_extra_importo')"
                                     append="€"
                                     class="v-form-control v-form-control__euro"
                                     placeholder="Scrivi l'importo desiderato"
                                     data-vv-name="don_extra_importo"
                                     data-vv-as="importo donazione extra"
                                     @keyup.native.enter.stop="next"
                                     @input="focusExtra"
                                     ref="inp_extra"
                                     v-validate="'decimal'"
                                     key="extra"
                            ></b-input>
                            <!-- Todo: ridurre lo spazio del campo scrivi l'importo desiderato in modo che sia a filo dell'euro -->
                        </b-input-group>
                    </b-form-radio>
                    <b-form-radio value="0"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline"
                                  data-vv-name="don_extra">
                        No, va bene la donazione attuale di {{ donazione_totale }}&euro;
                    </b-form-radio>
                </b-form-radio-group>
            </b-form-group>
            <div class="v-step__footer-step">
                <b-button
                        :disabled="!step_ok_donextra"
                        class="v-step__next-btn" variant="primary"
                        @click="next">Continua
                </b-button>
            </div>
        </div>

        <div class="v-step step" v-bind:class="{ 'active': step === 6 }" @click="focusStep" @keyup.enter.stop="next(check_privacy)">
            <b-form-group label="Consensi per la Race for the Cure">
                <div class="d-flex align-items-center justify-content-between">
                    <span><a class="text-light border-light border-bottom pb-1"
                                       href="https://www.raceforthecure.it/consensi-la-race-cure" target="_blank">Ho
                letto l'informativa completa</a></span>
                    <div class="v-step__next__wrapper-btn">
                        <a class="text-uppercase small text-white p-2 cursor_pointer"
                           :class="{'selected':form.check_lettura === 1}" @click="form.check_lettura = 1">Si</a>
                        <a class="text-uppercase small text-white p-2 cursor_pointer"
                           :class="{'selected':form.check_lettura === 0}" @click="form.check_lettura = 0">No</a>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                    <span>Desidero ricevere contatti informativi istituzionali personalizzati sulle attività di Komen Italia</span>
                    <div class="v-step__next__wrapper-btn">
                        <a class="text-uppercase small text-white p-2 cursor_pointer"
                           :class="{'selected':form.check_generico === 1}" @click="form.check_generico = 1">Si</a>
                        <a class="text-uppercase small text-white p-2 cursor_pointer"
                           :class="{'selected':form.check_generico === 0}" @click="form.check_generico = 0">No</a>
                    </div>
                </div>
            </b-form-group>
            <div class="v-step__footer-step">
                <b-button :disabled="!check_privacy" class="v-step__next-btn" variant="" @click="next">
                    Prosegui
                </b-button>
            </div>
        </div>

        <div class="v-step v-step__next step" v-bind:class="{ 'active': step === 7 }" @click="focusStep">
            <div class="v-step__next__title">Seleziona la modalità di donazione</div>
            <div class="v-step__next__subtitle">Totale <span>{{ donazione_totale }}&euro;</span></div>
            <div class="d-inline-block payment_select">
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="paypal_selected" name="metodo_pagamento"
                           class="custom-control-input"
                           value="PAYPAL"
                           v-model="form.metodo_pagamento"
                    >
                    <label class="custom-control-label" for="paypal_selected">
                        <img src="/static/svg/icons/paypal.svg" height="50">
                    </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="gestpay_selected" name="metodo_pagamento"
                           class="custom-control-input"
                           value="GESTPAY"
                           v-model="form.metodo_pagamento"
                    >
                    <label class="custom-control-label" for="gestpay_selected">
                        <img src="/static/svg/icons/credit_card.svg" height="40"> <span class="small">Carta di credito</span>
                    </label>
                </div>
                <!--<div class="custom-control custom-radio custom-control-inline">-->
                <!--<input type="radio" id="bonifico_selected" name="metodo_pagamento"-->
                <!--class="custom-control-input"-->
                <!--value="BONIFICO"-->
                <!--v-model="tipo_pagamento"-->
                <!--&gt;-->
                <!--<label class="custom-control-label d-flex align-items-center small" for="bonifico_selected">Bonifico-->
                <!--bancario</label>-->
                <!--</div>-->
            </div>
            <div class="w-100 mt-3">
                <div class="btn btn-sm v-step__next-btn btn-primary font-weight-bold text-uppercase" @click="dona">Procedi</div>
            </div>
        </div>

        <b-modal ref="modale_progetto" centered class="modal__race" lazy hide-footer>
            <div v-html="html_modale"></div>
        </b-modal>

        <div class="text-center pb-8">
            <div v-if="partner_principale" class="text-uppercase small pb-1">Partner</div>
            <div v-if="partner_principale" class="d-block pb-4 partner">
                <img :src=partner_principale height="60" class="img-fluid">
            </div>

            <!--<div v-if="partner_secondari" class="text-uppercase small pb-1">Local Major Partner</div>-->
            <div v-if="partner_secondari" class="d-block partner">
                <img :src=partner_secondari height="40">
            </div>
        </div>
        <div style="height: 30vh;"></div>
    </div>
</template>

<script>
    import BaseForm from "../BaseForm";
    import Riassunto from "./Riassunto";

    export default {
        name: "RaceItalia",
        extends: BaseForm,
        components: {Riassunto},
        mounted() {
            this.form.id_race = this.$store.state.id_race
            this.$http.get('/race/form/inserimento_dati/?type=province').then(response => {
                this.province = response.data.province
            }, () => {
                this.$notify({text:'C\'è stato un problema nel processare la tua richiesta, riprova più tardi',duration:10,type:'warn'})
            })
        },
        data() {
            return {
                form: {
                    email: null,
                    don_extra: null,
                    don_extra_importo: null,
                    maglia_cap: null,
                    maglia_cellulare: null,
                    maglia_citta: null,
                    maglia_cognome: null,
                    maglia_nome: null,
                    maglia_indirizzo: null,
                    maglia_provincia: null,
                    taglia_s_adulto: 0,
                    taglia_m_adulto: 0,
                    taglia_l_adulto: 0,
                    taglia_xl_adulto: 0,
                    taglia_s_rosa: 0,
                    taglia_m_rosa: 0,
                    taglia_l_rosa: 0,
                    taglia_xl_rosa: 0,
                    taglia_s_bambino: 0,
                    taglia_m_bambino: 0,
                    taglia_l_bambino: 0,
                    taglia_xl_bambino: 0,
                    metodo_pagamento: null,
                    check_generico: null,
                    check_lettura: null,
                },
                html_modale: null,
                province: null,
                submit_loader: false
            }
        }, methods: {
            dona() {
                if (!this.check_privacy)
                {
                    this.$notify({text: 'Devi fornire il consenso alla privacy per poter proseguire', type: 'warn'})
                    return false
                }
                this.submit_loader = true;
                this.$store.dispatch({
                    type: 'submit',
                    data: this.form,
                    id_form: this.id_form,
                    url: '/race/form/race_italia',
                    retry: 1
                }).then((response) => {
                    this.submit_loader = false
                    window.location.replace(response.data.redirect)
                }, () => {
                    this.submit_loader = false
                })
            }, show_modale_progetto() {
                let elem = document.getElementById('modale_progetto')
                this.html_modale = elem.innerHTML
                this.$refs.modale_progetto.show()
            }, checkFocus() {
                if (this.form.don_extra !== 'extra')
                    this.form.don_extra_importo = '';
            }, focusExtra() {
                if (this.form.don_extra_importo === '') return
                if (this.form.don_extra === 'extra') return
                this.form.don_extra = 'extra'

                if (this.$refs.extra)
                    this.$refs.extra.$el.querySelector('input').checked = true
            }, aumenta(taglia)
            {
                this.form[taglia]++
            }, diminuisci(taglia)
            {
                if (this.form[taglia] > 0)
                    this.form[taglia]--
            }
        }, computed: {
            testi_donazione() {
                let testi = this.$store.state.testi_donazione
                if (testi === null) testi = {}
                return testi
            }, check_maglia() {
                if (!this.compiled('maglia_nome', 'maglia_cognome', 'maglia_indirizzo', 'maglia_cap')) return false
                if (!this.compiled('maglia_citta', 'maglia_provincia', 'maglia_cellulare','email')) return false
                return true
            }, step_ok_donextra() {
                if (this.form.don_extra === null) return false
                if (this.form.don_extra === 'extra') {
                    if (this.form.don_extra_importo <= 0) return false
                }
                return true
            }, donazione_totale() {
                let extra = 0
                if (this.form.don_extra != null) {
                    if (this.form.don_extra === 'extra') {
                        extra = parseInt(this.form.don_extra_importo)
                        if (isNaN(extra)) extra = 0
                    } else
                        extra = parseInt(this.form.don_extra)
                }

                let tot_maglie = this.form.taglia_s_adulto + this.form.taglia_m_adulto
                    + this.form.taglia_l_adulto + this.form.taglia_xl_adulto
                    + this.form.taglia_s_bambino + this.form.taglia_m_bambino
                    + this.form.taglia_l_bambino + this.form.taglia_xl_bambino
                    + this.form.taglia_s_rosa + this.form.taglia_m_rosa
                    + this.form.taglia_l_rosa + this.form.taglia_xl_rosa


                let n_scaglioni = Math.ceil(tot_maglie / this.testi_donazione.maglia_num)
                return this.testi_donazione.base*tot_maglie + this.testi_donazione.con_maglia*n_scaglioni + extra
            },  check_privacy() {
                if (!this.form.check_lettura) return false
                if (!this.form.check_generico) return false
                return true
            },
        }
    }
</script>

<style scoped>
    @media only screen and (max-width: 500px) {
        .k-card-text {
            width: 100% !important;
        }
        .k-card-img {
            height: 100% !important;
            width: 100% !important;
            margin-left: auto !important;
            margin-right: auto !important;
        }
    }
    @media only screen and (max-width: 768px) and (min-width: 500px) {
        .k-card-text {
            width: 100% !important;
        }
        .k-card-img {
            float:left !important;
        }
    }
</style>
